const mutations = {
  FEATURE_FLAGS_UPDATED(state, newFlags = {}) {
    const normalizedFlags = { ...(newFlags || {}) }
    delete normalizedFlags.flags

    state.flags = normalizedFlags
    state.customContentCoursesEnabled =
      typeof newFlags.customContentCoursesEnabled === 'boolean'
        ? newFlags.customContentCoursesEnabled
        : false
    state.customContentVideosEnabled =
      typeof newFlags.customContentVideosEnabled === 'boolean'
        ? newFlags.customContentVideosEnabled
        : false
  },
}

export default mutations
